jQuery(document).ready(function() {
  if (jQuery('body').hasClass('template-pageTick'))
  {
      jQuery('.gpl-image-content').addClass('gray')
  }

  jQuery('.list-menu li:nth-child(2)').addClass('about-menu');

  jQuery('.add-to-cuscart-button').click(function(){
   jQuery('.view-cart').hide();
  var that = jQuery(this);
    console.log(that);
   var view = jQuery('.apart-img').closest('.view-cart');
 	var data = {
      "id": $(this).attr('data-id'),
      "quantity": 1
    }
      jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function (data) {
        $.ajax({
          type: 'GET',
          dataType: 'json',
          url: '/cart.json',
          success: function(cart){
            $('#cart-icon-bubble span').html(cart.item_count);
            that.parent().find('.view-cart').show();
          }
        });
      }
    });
  });

  if (jQuery('.footer wizard__footer .action.disabled')){
    jQuery('[data-next-text="Next"]').text('Begin');    
  }

  if (jQuery('body').hasClass('home-page'))
  {
      jQuery('.bolg-section ul.blog__posts li .article-card-wrapper').removeClass('underline-links-hover');
  }
  
  if (jQuery('body').hasClass('template-blog')){
    jQuery('.banner-text-wrap .banner-text').text('Research');
  }
  if (jQuery('body').hasClass('template-article')){
    jQuery('.banner-text-wrap .banner-text').text('Research');
  }
  //===========forgot breadcrumbs js

	jQuery('#RecoverPassword').on('click', function () {
		jQuery('body').addClass('forgot_pass_page');
    	if (jQuery('body').hasClass('forgot_pass_page')) {
        	jQuery('.login-text').html("Reset Account Password");
        }
	});
	jQuery('#HideRecoverPasswordLink').on('click', function () {
		jQuery('body').addClass('forgot_pass_page');
		if (jQuery('body').hasClass('forgot_pass_page')) {
			jQuery('.login-text').html("Login");
		}
	});

  jQuery(document).on('click','.ad_to_cart',function(){ 
    var ID = jQuery(this).find('.ad_to_cart_id').attr("var_id"); 
    jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: jQuery(this).find('.ad_to_cart_id').attr("var_id")
    },
      dataType: 'json', 
     success: function (data) { 
      jQuery('#CartCount span:first').text(data.quantity);
      console.log(data.quantity);
     
     } 
     });
  }) 
  
  jQuery('.quotes-wrapper').not('.slick-initialized').slick({
    slidesToShow: 2,
      slidesToScroll: 1,
      // autoplay: true,
      autoplaySpeed: 2000,
      loop:true,
        responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
             slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        }, 
      ],
    });

    jQuery('.articles-wrapper').not('.slick-initialized').slick({
    slidesToShow: 3,
      slidesToScroll: 1,
      // autoplay: true,
      //margin:30px,
      autoplaySpeed: 2000,
      loop:true,
        responsive: [
        {
          breakpoint: 786,
          settings: {
             slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
             slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        }, 
      ],
    });

    jQuery(window).scroll(function(){
      var sticky = jQuery('body'),
      scroll = jQuery(window).scrollTop();
      //console.log(scroll);
      
      if (scroll >= 100 || (scroll >= 5 && scroll <= 99)){ sticky.addClass('sticky_header');
      }else{ sticky.removeClass('sticky_header'); }
      
    });

    jQuery('input, select, text, textarea, email, password, tel').each(
		function (index) {
			//var input = jQuery(this);
			jQuery(this).on('focusout', function () {
				jQuery(this).parent().addClass("has-focus");
			});

			jQuery(this).on('focusout', function () {
				if (jQuery(this).val() == '') {
					jQuery(this).parent().removeClass("has-focus");
				}
			});

	});

    jQuery('.acc-head').on('click', function() {
		if(jQuery(this).hasClass('active')) {
			jQuery(this).siblings('.acc-content').slideUp();
			jQuery(this).removeClass('active');
		}
		else {
			jQuery('.acc-content').slideUp();
			jQuery('.acc-head').removeClass('active');
			jQuery(this).siblings('.acc-content').slideToggle();
			jQuery(this).toggleClass('active');
		}
	}); 
  
    //------------------- login-form validation ------------------
  
    jQuery('.btn_submit').on('click',function(){
  	
    	
        var email=jQuery('.login-form .input-email').val();
    	var pass=jQuery('.login-form .input-psswd').val();
        var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    	var emailflag=0,passflag=0;
    	if(email == '')
        {
          emailflag=1;
          jQuery('.error-email').show();
          jQuery('.login-form .input-email').addClass('input--error');
          jQuery('.error-email').text('Please enter your email.');

        }
        else
        {
          if(!test_pattern.test(email))
          {
            emailflag=1;
            jQuery('.error-email').show();
            jQuery('.login-form .input-email').addClass('input--error');
            console.log('test');
            jQuery('.error-email').text('The email address entered is invalid.');

          }
          else
          {
            jQuery('.error-email').hide();
            jQuery('.login-form .input-email').removeClass('input--error');
          }
        }
    	if(pass == '')
        {
             passflag=1;
          	 jQuery('.error-pass').show();
        	 jQuery('.login-form .input-psswd').addClass('input--error');
          	console.log('test1');
          	 jQuery('.error-pass').text('Please enter your password');
        }
    	else
        {
        	 jQuery('.error-pass').hide();
        	 jQuery('.login-form .input-psswd').removeClass('input--error');
        }
    	if( emailflag == 1 || passflag == 1 )
        {
            jQuery('.error-all').show();
            jQuery('.error-all').text('One or more fields have an error. Please check and try again.');
            return true;
        }
		else
          {
            jQuery('.error-all').hide();
            return false;
        }
  
  });

    jQuery('.top-btn').hide();
    jQuery(window).scroll(function(){
        if (jQuery(this).scrollTop() > 100) {
            jQuery('.top-btn').fadeIn('slow');
        } else {
            jQuery('.top-btn').fadeOut('slow');
        }
    });
    jQuery('.top-btn ').click(function(){
        jQuery("html, body").animate({ scrollTop: 0 }, 1200);
        return false;
    });

    jQuery('.contact_submit_btn').on('click', function () {

		var name = jQuery('#ContactForm-name').val();
		var email = jQuery('#ContactForm-email').val();
		var lname = jQuery('#ContactForm-Lastname').val();
		var msg = jQuery('#ContactForm-body').val();
   	    var phone = jQuery('#ContactForm-phone').val();
	
		var flag = 0;
		var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;


		
		if (name == "") {
			jQuery('.input-name').show();
			jQuery('#ContactForm-name').addClass('input--error');
			jQuery('.input-name').text('Please enter your name.');
			flag = 1;
		} else {
			jQuery('.input-name').hide();
			jQuery('#ContactForm-name').removeClass('input--error');
		}
		if (email == "") {
			jQuery('.input-email').show();
			jQuery('#ContactForm-email').addClass('input--error');
			jQuery('.input-email').text('Please enter an email address.');
			flag = 1;
		} else {
			if (!test_pattern.test(email)) {
				flag = 1;
				jQuery('.input-email').show();
				jQuery('#ContactForm-email').addClass('input--error');
				jQuery('.input-email').text('Please enter valid email address.');

			} else {

				jQuery('.input-email').hide();
				jQuery('#ContactForm-email').removeClass('input--error');
			}

		}
       
    	if (phone == "") {
			jQuery('.input-phone').show();
			jQuery('#ContactForm-phone').addClass('input--error');
			jQuery('.input-phone').text('Please enter your contact number.');
			flag = 1;
		} else {
			jQuery('.input-phone').hide();
			jQuery('#ContactForm-phone').removeClass('input--error');
		}

        if (msg == "") {
			jQuery('.input-msg').show();
			jQuery('#ContactForm-body').addClass('input--error');
			jQuery('.input-msg').text('Please enter your message.');
			flag = 1;
		} else {
			jQuery('.input-msg').hide();
			jQuery('#ContactForm-body').removeClass('input--error');
		}

		if (flag == 1) {
			jQuery('.error-all').show();
			jQuery('.error-all').text('One or more fields have an error. Please check and try again.');
          jQuery('.form-message.form-message--success').hide();
			return false;
		} else {
			jQuery('.error-all').hide();
            window.location.href = "/challenge#ContactForm";
			return true;
		}
    	
	});

    jQuery('.btn_submit').on('click',function(){

        var email = jQuery('#CustomerEmail').val();
		var pass = jQuery('#CustomerPassword').val();
		var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
		var emailflag = 0,
			passflag = 0;
		if (email == '') {
			emailflag = 1;
			jQuery('.error-email').show();
			jQuery('#CustomerEmail').addClass('input--error');
			jQuery('.error-email').text('Please enter your email address.');
		} else {
			if (!test_pattern.test(email)) {
				emailflag = 1;
				jQuery('.error-email').show();
				jQuery('#CustomerEmail').addClass('input--error');
				jQuery('.error-email').text('Please enter a valid email address.');
			} else {
				jQuery('.error-email').hide();
				jQuery('#CustomerEmail').removeClass('input--error');
			}
		}
		if (pass == '') {
			passflag = 1;
			jQuery('.error-pass').show();
			jQuery('#CustomerPassword').addClass('input--error');
			jQuery('.error-pass').text('Please enter your password.');
		} else {
			jQuery('.error-pass').hide();
			jQuery('#CustomerPassword').removeClass('input--error');
		}
		if (passflag == 1 || emailflag == 1) {
			jQuery('.error-all').show();
			jQuery('.error-all').text('One or more fields have an error. Please check and try again.');
			jQuery('#ResetSuccess').remove();
			return false;
		} else {
			jQuery('#ResetSuccess').remove();
			jQuery('error-all').hide();
			return true;
		}

    });

    //........customer register........//

    jQuery('.reg_btn').on('click',function(){

            var fname=jQuery('#RegisterForm-FirstName').val();
            var lname=jQuery('#RegisterForm-LastName').val();
            var email=jQuery('#RegisterForm-email').val();
            var password=jQuery('#RegisterForm-password').val();
            //console.log(password);
            //var confirePassword=jQuery('#CreateconfirmPassword').val();
            var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
            var fflag,lflag,emailflag,passflag = 0; 
            var con_passwd_err =0;
            if(fname == "")
            {
              jQuery('#RegisterForm-FirstName').addClass('input--error');
              jQuery('.error-fname').show();
              jQuery('.error-fname').text('Please enter your first name.');
              fflag=1;
            }
            else
            {	
              jQuery('#RegisterForm-FirstName').removeClass('input--error');
              jQuery('.error-fname').hide();
            }
            if(lname == "")
            {
              jQuery('#RegisterForm-LastName').addClass('input--error');
              jQuery('.error-lname').show();
              jQuery('.error-lname').text('Please enter your last name.');
              lflag=1;
            }
            else
            {	
              jQuery('#RegisterForm-LastName').removeClass('input--error');
              jQuery('.error-lname').hide();
            }
            if(email == '')
            {
              emailflag=1;
              jQuery('.error-email').show();
              jQuery('#RegisterForm-email').addClass('input--error');
              jQuery('.error-email').text('Please enter your email.');

            }
            else
            {
              if(!test_pattern.test(email))
              {
                emailflag=1;
                jQuery('.error-email').show();
                jQuery('#RegisterForm-email').addClass('input--error');
                jQuery('.error-email').text('The email address entered is invalid.');

              }
              else
              {
                jQuery('.error-email').hide();
                jQuery('#RegisterForm-email').removeClass('input--error');
              }
            }
            if(password == "")
            {
              passflag = 1;
              	jQuery('.error-password').show();
                jQuery('.input-psswd').addClass('input--error');
                jQuery('.error-password').text('Please enter your password.');

            }
            else
            {	
              jQuery('.input-psswd').removeClass('input--error');
              jQuery('.error-password').hide();
            }
        
            if(fflag == 1 || lflag == 1 || emailflag == 1 || passflag == 1 )
            {
              jQuery('.error-all').show();
              jQuery('.error-all').text('One or more fields have an error. Please check and try again.');
              return false;
            }
            else
            {
              jQuery('.error-suc').show();
              jQuery('.error-suc').text('Thank you for your message, we will be in contact with you shortly.');
			
              jQuery('.error-all').hide();
              return true;
            }
   });

   //...................................forgot pwd js...................................//
          var url_reset=window.location.href;
          url_reset = url_reset.split("#");
          console.log(url_reset);
          url_reset = url_reset[url_reset.length-1];
          if(url_reset == "recover")
          {	
            jQuery('.login-text').html("Forgot Your Password?");
          }

          jQuery('.recover_btn').on('click',function(e){

            var email=jQuery('#RecoverEmail').val();
            var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
            var flag=0;
            jQuery('.error-all').hide();


            if(email == '')
            {
              flag=1;
              jQuery('.error-email').show();
              jQuery('#RecoverEmail').addClass('input--error');
              jQuery('.error-email').text('Please enter your email.');
              return false;
            }
            else
            {
              if(!test_pattern.test(email))
              {
                jQuery('.error-email').show();
                jQuery('#RecoverEmail').addClass('input--error');
                jQuery('.error-email').text('The email address entered is invalid.');
                flag=1;
              }
              else
              {
                jQuery('.error-email').hide();
                jQuery('#RecoverEmail').removeClass('input--error');
              }
            }
            if(flag == 1)
            {
              return false;
            }
            else
            {
              return true;
            }
          });

    jQuery('.reset_btn').on('click', function () {


		var res_passwd = jQuery(".template-customers-reset_password .input-psswd").val();
		var con_passwd = jQuery(".template-customers-reset_password .input-con-psswd").val();
		var res_passwd_err = 0;
		var con_passwd_err = 0;
		if (res_passwd.trim() == "") {
			jQuery('.pass-error').show();
			res_passwd_err = 1;
			jQuery(".input-psswd").addClass("input--error");
			jQuery('.pass-error').text("Please enter your password.");

		}
        else {
			res_passwd_err = 0;
			jQuery('.pass-error').hide();
			jQuery(".input-psswd").removeClass("input--error");
		}

		if (con_passwd.trim() == "") {
			con_passwd_err = 1;
			jQuery('.confirm-pass-error').show();
			jQuery(".template-customers-reset_password .input-con-psswd").addClass("input--error");
			jQuery('.confirm-pass-error').text("Please enter your confirmation password.");
		} else if (res_passwd != con_passwd) {
			con_passwd_err = 2;
			jQuery("#ResetPassword").addClass("input--error");
			jQuery(".template-customers-reset_password .input-con-psswd").addClass("input--error");
          	jQuery('.confirm-pass-error').text("Please enter your right password.");
		} else {
			con_passwd_err = 0;
			jQuery("#ResetPassword").removeClass("input--error");
			jQuery(".template-customers-reset_password .input-con-psswd").removeClass("input--error");
			jQuery('.confirm-pass-error').hide();
		}


		if (res_passwd_err == 1 || con_passwd_err == 1) {
          
			jQuery('.error-all').show();
        	jQuery('.error-all').text('One or more fields have an error. Please check and try again.');  
        	return false;

		} else {
			if (con_passwd_err == 2) {

				jQuery(".error-all").text("Password and confirmation password does not match.");
				jQuery(".error-all").show();
				return false
                
			} else {
				
				jQuery(".error-all").hide();
				return true;
			}
		}
	}); 
  
    jQuery('.btn-add-addresses').on('click',function(){
  		var fname=jQuery('#AddressFirstNameNew').val();
    	var lname=jQuery('#AddressLastNameNew').val();
    	var add=jQuery('#AddressAddress1New').val();
    	var add2=jQuery('#AddressAddress2New').val();
    	var city=jQuery('#AddressCityNew').val();
        var country=jQuery('#AddressCountryNew').val();
    	var zip=jQuery('#AddressZipNew').val();
    	var phone=jQuery('#AddressPhoneNew').val();
    	var company=jQuery('#AddressCompanyNew').val();
		
    	var fflag=0,lflag=0,addflag=0,add2flag=0,cityflag=0,countryflag=0,zipflag=0,phoneflag=0,companyflag=0;
    	 
		if(fname == "")
        {
          	jQuery('.error-fname').show();
        	jQuery('#AddressFirstNameNew').addClass('input--error');
          	jQuery('.error-fname').text("Please enter your first name.");
        	fflag=1;
        }
    	else
        {
			jQuery('.error-fname').hide();
        	jQuery('#AddressFirstNameNew').removeClass('input--error');
        }
    	if(lname == "")
        {
        	jQuery('.error-lname').show();
          	jQuery('#AddressLastNameNew').addClass('input--error');
          	jQuery('.error-lname').text("Please enter your last name.");
          	lflag=1;
        }
    	else
        {
			jQuery('.error-lname').hide();
        	jQuery('#AddressLirstNameNew').removeClass('input--error');
        }
    	if(add == "")
        {
        	jQuery('.error-add1').show();
          	jQuery('#AddressAddress1New').addClass('input--error');
          	jQuery('.error-add1').text("Please enter your address.");
          	addflag=1;
        }
    	else
        {
			jQuery('.error-add1').hide();
        	jQuery('#AddressAddress1New').removeClass('input--error');
        }
    	
    	if(add2 == "")
        {
        	jQuery('.error-add2').show();
          	jQuery('#AddressAddress2New').addClass('input--error');
          	jQuery('.error-add2').text("Please enter your address.");
          	add2flag=1;
        }
    	else
        {
			jQuery('.error-add2').hide();
        	jQuery('#AddressAddress2New').removeClass('input--error');
        }
    	if(city == "")
        {
        	jQuery('.error-city').show();
          	jQuery('#AddressCityNew').addClass('input--error');
          	jQuery('.error-city').text("Please enter your city.");
          	cityflag=1;
        }
    	else
        {
			jQuery('.error-city').hide();
        	jQuery('#AddressCityNew').removeClass('input--error');
        }
    	if(zip == "")
        {
        	jQuery('.error-zip').show();
          	jQuery('#AddressZipNew').addClass('input--error');
          	jQuery('.error-zip').text("Please enter your zip code.");
          	zipflag=1;
        }
    	else
        {
			jQuery('.error-zip').hide();
        	jQuery('#AddressZipNew').removeClass('input--error');
        }
    	
    	if(phone == "")
        {
        	jQuery('.error-phone').show();
          	jQuery('#AddressPhoneNew').addClass('input--error');
          	jQuery('.error-phone').text("Please enter your phone number.");
          	phoneflag=1;
        }
    	else
        {
			jQuery('.error-phone').hide();
        	jQuery('#AddressPhoneNew').removeClass('input--error');
        }
    	if(company == "")
        {
        	jQuery('.error-company').show();
          	jQuery('#AddressCompanyNew').addClass('input--error');
          	jQuery('.error-company').text("Please enter your company.");
          	companyflag=1;
        }
    	else
        {
			jQuery('.error-company').hide();
        	jQuery('#AddressCompanyNew').removeClass('input--error');
        }
    	
    	if(fflag==1 || lflag==1 || addflag==1 || add2flag==1 || cityflag==1 || zipflag==1 || phoneflag==1 || companyflag==1)
        {
            
        	jQuery('.error-all').show();
          	jQuery('.error-all').html("One or more fields have an error. Please check and try again.");
          	return false;
        }
    	else
        {
        	jQuery('.error-all').hide();
          	return true;
        }
  });

  jQuery('.add-cancle-address-form').on('click',function(){

    jQuery('.error-all').hide();
    jQuery('#AddressPhoneNew').removeClass('input--error');
    jQuery('.error-phone').hide();
    jQuery('#AddressZipNew').removeClass('input--error');
    jQuery('.error-zip').hide();
    jQuery('#AddressCityNew').removeClass('input--error');
    jQuery('.error-city').hide();
    jQuery('#AddressAddress2New').removeClass('input--error');
    jQuery('.error-add2').hide();
    jQuery('#AddressAddress1New').removeClass('input--error');
    jQuery('.error-add1').hide();
    jQuery('#AddressCompanyNew').removeClass('input--error');
    jQuery('.error-company').hide();
    jQuery('#AddressLastNameNew').removeClass('input--error');
    jQuery('.error-lname').hide();
    jQuery('#AddressFirstNameNew').removeClass('input--error'); 
    jQuery('.error-fname').hide();
  });  

  //-------------------- Reset password form validation ------------------//

	
  	
  jQuery('.reset_btn').on('click', function () {

		var res_passwd = jQuery(".input-psswd").val();
		var con_passwd = jQuery(".input-con-psswd").val();
		var res_passwd_err = 0;
		var con_passwd_err = 0;
		if (res_passwd.trim() == "") {
			jQuery('.pass-error').show();
			res_passwd_err = 1;
			jQuery(".input-psswd").addClass("input--error");
			jQuery('.pass-error').text("Please enter your password.");

		} else {
			res_passwd_err = 0;
			jQuery('.pass-error').hide();
			jQuery(".input-psswd").removeClass("input--error");
		}

		if (con_passwd.trim() == "") {
			con_passwd_err = 1;
			jQuery('.confirm-pass-error').show();
			jQuery(".template-customers-reset_password .input-con-psswd").addClass("input--error");
			jQuery('.confirm-pass-error').text("Please enter your confirmation password.");
		} else if (res_passwd != con_passwd) {
			con_passwd_err = 2;
			jQuery("#ResetPassword").addClass("input--error");
			jQuery(".template-customers-reset_password .input-con-psswd").addClass("input--error");
          	jQuery('.confirm-pass-error').text("Please enter your right password.");
		} else {
			con_passwd_err = 0;
			jQuery("#ResetPassword").removeClass("input--error");
			jQuery(".template-customers-reset_password .input-con-psswd").removeClass("input--error");
			jQuery('.confirm-pass-error').hide();
		}


		if (res_passwd_err == 1 || con_passwd_err == 1) {
          
			jQuery('.reset-error-all').show();
        	jQuery('.reset-error-all').text('One or more fields have an error. Please check and try again.');  
        	return false;

		} else {
			if (con_passwd_err == 2) {

				jQuery(".reset-error-all").text("Password and confirmation password does not match.");
				jQuery(".reset-error-all").show();
				return false
                
			} else {
				
				jQuery(".reset-error-all").hide();
				return true;
			}
		}
	});

  if (jQuery('body').hasClass('template-article'))
  {
      jQuery('.header__inline-menu li:nth-child(5) .header__menu-item span').addClass('header__active-menu-item');
  }
})